import { types } from "mobx-state-tree";
import { v4 as uuid } from "uuid";
export const TileCommentModel = types
    .model("TileComment", {
    key: types.optional(types.identifier, () => uuid()),
    uid: types.string,
    text: types.string,
    selectionInfo: types.maybe(types.string),
    deleted: false
})
    .actions(self => ({
    delete() {
        self.deleted = true;
    }
}));
export const TileCommentsModel = types
    .model("TileComments", {
    comments: types.array(TileCommentModel),
    tileId: types.string
})
    .volatile(self => ({
    visible: true
}))
    .actions(self => ({
    setVisible(visible) {
        self.visible = visible;
    },
    addComment(comment) {
        self.comments.push(comment);
    },
    getCommentAtIndex(index) {
        return self.comments[index];
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlsZS1jb21tZW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2RlbHMvdGlsZXMvdGlsZS1jb21tZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsS0FBSyxFQUFZLE1BQU0saUJBQWlCLENBQUM7QUFDbEQsT0FBTyxFQUFFLEVBQUUsSUFBSSxJQUFJLEVBQUUsTUFBTSxNQUFNLENBQUM7QUFFbEMsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUcsS0FBSztLQUNwQyxLQUFLLENBQUMsYUFBYSxFQUFFO0lBQ3BCLEdBQUcsRUFBRSxLQUFLLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxVQUFVLEVBQUUsR0FBRyxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUM7SUFDbkQsR0FBRyxFQUFFLEtBQUssQ0FBQyxNQUFNO0lBQ2pCLElBQUksRUFBRSxLQUFLLENBQUMsTUFBTTtJQUNsQixhQUFhLEVBQUUsS0FBSyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDO0lBQ3hDLE9BQU8sRUFBRSxLQUFLO0NBQ2YsQ0FBQztLQUNELE9BQU8sQ0FBQyxJQUFJLENBQUUsRUFBRSxDQUFDLENBQUM7SUFDakIsTUFBTTtRQUNKLElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO0lBQ3RCLENBQUM7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUdKLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLEtBQUs7S0FDbkMsS0FBSyxDQUFDLGNBQWMsRUFBRTtJQUNyQixRQUFRLEVBQUUsS0FBSyxDQUFDLEtBQUssQ0FBQyxnQkFBZ0IsQ0FBQztJQUN2QyxNQUFNLEVBQUUsS0FBSyxDQUFDLE1BQU07Q0FDckIsQ0FBQztLQUNELFFBQVEsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDakIsT0FBTyxFQUFFLElBQUk7Q0FDZCxDQUFDLENBQUM7S0FDRixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ2hCLFVBQVUsQ0FBQyxPQUFnQjtRQUN6QixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztJQUN6QixDQUFDO0lBRUQsVUFBVSxDQUFDLE9BQTZCO1FBQ3RDLElBQUksQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQzlCLENBQUM7SUFFRCxpQkFBaUIsQ0FBQyxLQUFhO1FBQzdCLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM5QixDQUFDO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==